import React, { useState, useEffect, useCallback } from "react";
import { useIsReadOnlyManager } from "@/shared/readOnlyManager";
import {connect} from 'react-redux';
import TabNav from "./components/Tabnav";
import { useNavigate, useLocation } from "react-router-dom";
import {Themed} from '@/theme'
import {getLeaderboards} from '@/services/program/getLeaderboards'
import { getCascadingApprovalsCount,getManagerCascadingApprovalsCount } from "@/services/program/budget";

let ParticipantTabNavsBase = ({program}) => {
  const [leaderboardCount, setLeaderboardCount] = useState(0);
  useEffect(() => {
    if( program?.id ) {
      getLeaderboards(program.organization_id, program.id, true)
      .then( count => {
        setLeaderboardCount(count)
      })
    }
    return () => {
    }
  }, []);
  return <Themed leaderboardCount={leaderboardCount} component={'ParticipantTabnav'} />
};

ParticipantTabNavsBase =  connect((state) => ({
  program: state.program
}))(ParticipantTabNavsBase);

export const ParticipantTabNavs = () => {
  return <ParticipantTabNavsBase />
};

let MANAGER_ITEMS = [
      { title: "Dashboard", icon: "dashboard", to: "/manager/home" }
  ];

let ManagerTabNavsTmp = ({organization, program, rootProgram, auth}) => {
  const [cascadingApprovalsCount,setCascadingApprovalsCount] = useState(0)
  const [managerCascadingApprovalsCount,setManagerCascadingApprovalsCount] = useState(0)
  
  const fetchCascadingApprovalsCount = useCallback(() => {
    getCascadingApprovalsCount(organization, program)
      .then((res) => {
        if (res && res.status === 200) {
          setCascadingApprovalsCount(res.data);
        }
      })
      .catch((err) => console.log(err));
  }, [organization, program, rootProgram]);

  const fetchManagerCascadingApprovalsCount = useCallback(() => {
    // A referral-submission pending award is created regardless of use_cascading_approvals
    // (ReferralService never reads that flag) — it's the only thing that would ever be
    // pending on a program with cascading approvals off, since every other award type
    // auto-issues immediately in that state. Scope the count accordingly so the badge
    // doesn't imply awards a manager on a non-cascading program could never approve.
    const category = rootProgram?.use_cascading_approvals ? null : "referral";
    getManagerCascadingApprovalsCount(organization, program, category)
      .then((res) => {
        if (res && res.status === 200) {
          setManagerCascadingApprovalsCount(res.data?.managerApprovalPendingCount ?? 0);
        }
      })
      .catch((err) => console.log(err));
  }, [organization, program, rootProgram]);
  
  const [managerItems,setManagerItems] = useState(MANAGER_ITEMS);
  const readOnly = useIsReadOnlyManager();
  const [path, setPath] = useState(null);
  const location = useLocation();
  useEffect(() => {
    let path = location?.pathname.substring(
      location.pathname.lastIndexOf("/") + 1
    );
    setPath(path);
  }, [location]);
  let navigate = useNavigate();

  let newItems = [...MANAGER_ITEMS];
  if (program.uses_social_wall > 0) {
    newItems.push({
      title: "Social Wall",
      icon: "spire",
      to: `/manager/nspire-wall`,
    });
  }

  if (program.uses_leaderboards > 0) {
    newItems.push({
      title: "Leaderboard",
      icon: "leaderboard",
      to: `/manager/leaderboards`,
    });
  }

  newItems.push({
    title: "Reports",
    icon: "report",
    to: `/manager/report`,
  });

  if (!readOnly) {
    newItems.push({
      title: "Push Notification",
      icon: "budgetcascading",
      to: `/manager/mobile-app`,
    });
  }

  if (auth?.isAdmin && !readOnly) {
    newItems.push({
      title: "Manage Program",
      icon: "applicationedit",
      to: `/manager/manage/program`,
    });
  }


  useEffect(() => {
    if (organization && program) {
      fetchManagerCascadingApprovalsCount();
    }
  }, [organization, program]);

  useEffect(() => {
    //fetchCascadingApprovalsCount();
//console.log(rootProgram);
    if (organization && program) {
      let cascadingItems = [...newItems];
      if (rootProgram?.use_cascading_approvals > 0 || managerCascadingApprovalsCount > 0) {
        cascadingItems.push({
          title: "Approvals",
          icon: "budgetcascading",
          to: `/manager/cascading-approvals`,
        });
        setManagerItems(cascadingItems);
      } else {
        setManagerItems(newItems);
      }
    }
  }, [ organization , program, auth ]);
//console.log('managerCascadingApprovalsCount:', managerCascadingApprovalsCount);
  if (!program) return "loading...";
  return (
    <div className="tab-navs items-3">
      <ul className="horizontal">
        {managerItems.map((item, key) => {
          return (
            <li key={key} onClick={() => navigate(item.to)} className="tab-nav-wrap">
              <TabNav
                title={item.title}
                icon={item.icon}
                isActive={location.pathname === item.to || location.pathname.startsWith(item.to + '/')}
              />
                {item.title === 'Approvals' && managerCascadingApprovalsCount > 0 && (
                <span className="approval-count">{managerCascadingApprovalsCount}</span>
                )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};
ManagerTabNavsTmp =  connect((state) => ({
  organization: state.organization,
  program: state.program,
  rootProgram: state.rootProgram,
  auth: state.auth
}))(ManagerTabNavsTmp);

export const ManagerTabNavs = () => {
    return <ManagerTabNavsTmp />
}
